import { useList } from 'admin';
import { InspectionCompany } from 'api';

export const useAllInspectionCompanies = () => {
  return useList<InspectionCompany>({
    dataProviderName: 'inspections',
    filters: [{ field: 'is_active', operator: 'eq', value: true }],
    pagination: {
      pageSize: 10000, // fetch all companies
    },
    resource: '/v1/companies/',
  });
};
